const ArrowLongLeftIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='10' viewBox='0 0 20 10' fill='none'>
    <path
      className='dark:child:stroke-primary-500'
      d='M4.81097 8.561L1.06097 4.811M1.06097 4.811L4.81097 1.061M1.06097 4.811H19.061'
      stroke='#91B1BE'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default ArrowLongLeftIcon;
